export const APP_NAME = 'CatHouse Elite';
export const API_BASE = '/api';
/** Mã công ty mặc định cho màn đăng nhập (một tenant / một tên miền). */
export const DEFAULT_TENANT = (import.meta.env.VITE_TENANT_SLUG as string | undefined) ?? '';
/** Nhận diện Elite Capital (chép từ website/elitecapital-next/public/assets/brand) — dùng khi công ty chưa đặt logo riêng. */
export const BRAND_NAME = 'Elite Capital';
export const BRAND_LOGO_ON_DARK = '/brand/logo-white.png';
export const BRAND_LOGO_ON_LIGHT = '/brand/logo-dark.png';
export const BRAND_MARK_ON_DARK = '/brand/mark-white.png';
export const BRAND_MARK_ON_LIGHT = '/brand/mark-dark.png';
